import { Component, OnInit } from '@angular/core';
import { faPrint } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'odl-header-report',
    templateUrl: './header-report.component.html',
    styleUrls: ['./header-report.component.scss']
})
export class HeaderReportComponent implements OnInit {

    faPrint = faPrint;
    
    constructor() { }

    ngOnInit() {
    }

}
